// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import AddressSharedStyles from "@ces/App/SharedStyles/LocationPage/LocationAddressStyles";
import { addressDrawerPickUpLocationSelectorStyles } from "@ces/Overrides/Widgets/Header/AddressDrawerPickUpLocationSelector";
import Change from "@ces/XDL/Icons/Change";
import { css } from "styled-components";

addressDrawerPickUpLocationSelectorStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

addressDrawerPickUpLocationSelectorStyles.headerText = {
    variant: "h6",
    css: css`
        margin: 0;
    `,
};

addressDrawerPickUpLocationSelectorStyles.warehouseAddress = {
    ...AddressSharedStyles,
};

addressDrawerPickUpLocationSelectorStyles.titleWrapper = {
    css: css`
        display: flex;
        gap: 16px;
        align-items: center;
        margin-bottom: 12px;
    `,
};

addressDrawerPickUpLocationSelectorStyles.changeLink = {
    typographyProps: {
        size: 12,
        lineHeight: "13px",
    },
    icon: {
        iconProps: {
            src: Change,
            size: 12,
        },
    },
    css: css`
        margin: 0;
    `,
};
